<template>
    <span class="block overflow-hidden text-ellipsis">{{ displayValue }}</span>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps<{
    phone?: string | null;
}>();

const displayValue = computed(() => {
    if (!props.phone || String(props.phone).length === 0) {
        return '-';
    }
    return props.phone;
});
</script>
